// extracted by mini-css-extract-plugin
module.exports = {"aisSearchBox":"SearchBox_aisSearchBox__pu9yu","aisSearchBoxForm":"SearchBox_aisSearchBoxForm__3AXRq"};